<template>
<div id="luckdraw">
    <Luckdraw />
</div>
</template>

<script>
import Luckdraw from '@/components/Luckdraw.vue'
export default {
    name: 'About',
    data (){
        return {

        }
    },
    components: {
        Luckdraw,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>

</style>
